import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  makeStyles, Button,
} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import CheckIcon from '@material-ui/icons/Check';
import DoneAllIcon from '@material-ui/icons/DoneAll';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import {
  formatDate
} from '../common/formatter';
import { api_call, getDeviceSpeedUnit, isGpsMT3VProtocolDevice, is_null, removeItemFromArray, returnMobileApp } from '../helpers/untils';
import BtCommandSendDialog from './BtCommandSendDialog';
import ShockAlamDialog from './ShockAlamDialog';
import CommandSendDialogWrapper from './CommandSendDialogWrapper';
import { DEVICE_TYPE } from '../config/constant';

const SIGNAL_MIN = 20
const SIGNAL_MAX = 120

const SignalMarks = [
  {
    value: SIGNAL_MIN,
    label: 'Week',
  },
  {
    value: SIGNAL_MAX,
    label: 'Strong',
  },
];


const useStyles = makeStyles((theme) => ({
  bluetoothModal: {
    // width: '600px',
  },
}));

const CommandSendDialog = (props) => {
  const { onClose, selectedValue, open, commandsDetail, history, coHostDeviceDetail, device, userInfo, deviceId } = props;
  const user = userInfo ?? useSelector((state) => state.session.user);
  //console.log("user:::", user)
  const classes = useStyles();

  const [userDeviceItem, setUserDeviceItem] = useState({});
  const [commands, setCommands] = useState([]);
  const initCommandList = async () => {
    if (localStorage.getItem('page') == 'overspeed' || localStorage.getItem('page') == 'bluetooth' || localStorage.getItem('page') == "shock" || localStorage.getItem('page') == 'geofence') {
      const urlParams = new URLSearchParams(window.location.search);
      const deviceId = urlParams.get('deviceId');
      if (deviceId) {
        const response = await api_call(`/api/device-control-menu/${deviceId}?temporary=0`);
        if (response.ok) {
          const data = await response.json()
          const commandList = data['commandList'] // ['Kill', 'Unkill', 'Geofence'];
          setCommands(commandList)
        } else {
          setCommands([])
        }
        if (localStorage.getItem('page') == 'overspeed') {
          handleListItemClick('Overspeed');
        }
        if (localStorage.getItem('page') == 'geofence') {
          handleListItemClick('Geofence');
        }
        if (localStorage.getItem('page') == 'bluetooth') {
          handleListItemClick('Bluetooth');
        }
        if (localStorage.getItem('page') == 'shock') {
          handleListItemClick('ShockAlam');
        }
      }
    }
    else {
      const deviceId = device?.id
      if (deviceId) {
        const response = await api_call(`/api/device-control-menu/${deviceId}?temporary=0`);
        if (response.ok) {
          const data = await response.json()
          const commandList = data['commandList'] // ['Kill', 'Unkill', 'Geofence'];
          setCommands(commandList)
        } else {
          setCommands([])
        }
      }
    }
  }

  useEffect(() => {
    initCommandList()
  }, [device?.id, coHostDeviceDetail?.id])

  const showToast = (msg) => {
    window.alert(msg)
  }
  const handleClose = () => {
    onClose(selectedValue);
  };

  const [title, setTitle] = useState("");
  const defaultCount = 80
  const [count, setCount] = useState(defaultCount);

  useEffect(() => {
    if (commandsDetail) {
      if (!is_null(commandsDetail?.Overspeed?.count)) {
        setCount(commandsDetail?.Overspeed?.count)
      }
    }
  }, [commandsDetail?.Overspeed?.count])

  const handleListItemClick = async (value) => {
    var response = null;
    // onClose(value);
    if (value === "Bluetooth") {
      // count = prompt(value, "input value");
      if (localStorage.getItem('page') == 'bluetooth') {
        response = await api_call(`/api/devices/${deviceId}`);
      }
      else {
        response = await api_call(`/api/devices/${device.id}`);
      }

      if (response.ok) {
        let responseObj = await response.json()
        setUserDeviceItem(responseObj)
        setTitle(value);
        setOpenBluetoothChild(true);
      } else {
        showToast("Invalid request")
      }
      return;
    }
    if (value === "ShockAlam") {
      // count = prompt(value, "input value");
      if (localStorage.getItem('page') == "shock") {
        response = await api_call(`/api/devices/${deviceId}`);
      }
      else {
        response = await api_call(`/api/devices/${device.id}`);
      }
      if (response.ok) {
        let responseObj = await response.json()
        setUserDeviceItem(responseObj)
        setTitle(value);
        setOpenShockAlamDialog(true);
      } else {
        showToast("Invalid request")
      }
      return;
    }
    if (value === "Geofence") {
      if (localStorage.getItem('page') == "geofence") {
        var url = `/geofences/${deviceId}`;
      }
      else {
        var url = `/geofences/${props.deviceId}`;
      }
      history.push(url);
      onClose(selectedValue);
      return false
    }
    if (value === "Overspeed" || value === "Kill" || value === "Unkill") {
      // count = prompt(value, "input value");
      setTitle(value);
      setOpenChild(true);
      return;
    }
    response = await api_call(`/api/command?command=${value}&deviceId=${props.deviceId}&userId=${user.id}`);
    if (response.ok) {
      console.log("Sent Command.");
    }
    onClose(selectedValue);
  };

  const [openChild, setOpenChild] = React.useState(false);

  const handleChildClose = () => {
    console.log("cancel");
    if (localStorage.getItem('page') == 'overspeed' || localStorage.getItem('page') == 'bluetooth' || localStorage.getItem('page') == "shock" || localStorage.getItem('page') == 'geofence') {
      // const status = 'success';
      // window.location.href = 'moovetrax://return?status=' + status;
      returnMobileApp(history);
    }
    else {
      setOpenChild(false);
    }
  };
  const handleChildSend = async () => {
    // var command = title;
    // if(title === "Kill/Unkill") command = "Kill";
    var url = '';
    if (localStorage.getItem('page') == 'overspeed' || localStorage.getItem('page') == 'bluetooth' || localStorage.getItem('page') == "shock" || localStorage.getItem('page') == 'geofence') {
      url = `/api/command?command=${title}&deviceId=${deviceId}&userId=${user.id}`;
    }
    else {
      url = `/api/command?command=${title}&deviceId=${props.deviceId}&userId=${user.id}`;
    }

    if (title === "Overspeed" || title === "Geofence") url = url + `&count=${count}`;
    const response = await api_call(url);
    if (response.ok) {
      console.log("Sent Command.");
    }
    if (localStorage.getItem('page') == 'overspeed' || localStorage.getItem('page') == 'bluetooth' || localStorage.getItem('page') == "shock" || localStorage.getItem('page') == 'geofence') {
      returnMobileApp(history)
    }
    else {
      setOpenChild(false);
    }
  };

  const getDetail = (command) => {
    // var tempCommand = command;
    // if(command === "Kill/Unkill") tempCommand = "Kill";
    for (var key in commandsDetail) {
      if (key === command) {
        if (key === "Overspeed") return commandsDetail[key].count + getDeviceSpeedUnit(device.distance_unit);
        else if (key === "Geofence") return "";
        return formatDate(commandsDetail[key].createdAt);
      }
    }
    return false;
  }
  const getStatus = (command) => {
    // if(command === "Kill/Unkill") command = "Kill";
    return commandsDetail[command].status;
  }

  const [openBluetoothChild, setOpenBluetoothChild] = useState(false);

  const [openShockAlamDialog, setOpenShockAlamDialog] = useState(false);

  return (
    <>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>Select Command</DialogTitle>
        <List sx={{ pt: 0 }}>
          {commands.map((commandItem) => {
            const command = commandItem.CommandName
            return (
              <ListItem button onClick={() => handleListItemClick(command)} key={command}>
                {/* <ListItemAvatar>
              <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                <PersonIcon />
              </Avatar>
            </ListItemAvatar> */}
                <ListItemText primary={commandItem.CommandLabel} secondary={getDetail(command)} />
                {getDetail(command) &&
                  (
                    getStatus(command) === 'success' ?
                      <DoneAllIcon color="secondary" /> :
                      <CheckIcon color="disabled" />
                  )
                }
              </ListItem>
            )
          })}
        </List>
      </Dialog>

      <Dialog open={openChild} onClose={handleChildClose}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {!(title === "Kill" || title === "Unkill") ? "Please enter the value here..." : "Are you sure?"}
          </DialogContentText>
          {!(title === "Kill" || title === "Unkill") && <TextField
            autoFocus
            // margin="dense"
            id="value"
            label={title}
            // type="number"
            fullWidth
            variant="standard"
            value={count}
            onChange={(e) => { setCount(e.target.value) }}
            InputProps={{
              endAdornment: <InputAdornment position="end">{(title === "Overspeed") ? getDeviceSpeedUnit(device.distance_unit) : "Miles Radius"}</InputAdornment>,
            }}
          />}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleChildClose}>Cancel</Button>
          <Button onClick={handleChildSend}>Send</Button>
        </DialogActions>
      </Dialog>

      {
        (openBluetoothChild) ? (
          <BtCommandSendDialog
            device={device}
            userDeviceItem={userDeviceItem}
            openBluetoothChild={openBluetoothChild}
            setOpenBluetoothChild={setOpenBluetoothChild}
          />
        ) : (<></>)
      }

      {
        (openShockAlamDialog) ? (
          <ShockAlamDialog
            device={device}
            userDeviceItem={userDeviceItem}
            open={openShockAlamDialog}
            setOpen={setOpenShockAlamDialog}
          />
        ) : (<></>)
      }
    </>
  );
}

export default CommandSendDialog;
